import { RenewalCoverageAcceptOptionsValue } from "src/app/_common/_enum/module.enum";

export class BindRenewalData {
    accountName: string = '';
    renewalNumber: any;
    billingType: string = '';
    payment: any = '';
    paymentPlan: string = '';
    paymentPlanCode: string = '';
    expiringPolicies: any = [];
    renewingPolicies: any = [];
    comment: string = '';
    attachments:any = [];
    acknowledge: any = {
        terms: false,
        payPremium: false
    };
}

export class CommonPolicyDetails {
    policyNumber: string = '';
    quoteDocument: any = null;
    renewOption: string = '';
    doNotRenewReason: string = '';
    remarks: string = '';
    isSubjectivities: boolean = false;
    coverages: any  = [];
    productName: string = '';
    isPrimaryLine: boolean = false;
}

export class AdditionalChangesCoverage {
    isAdditionalCoverage: boolean = false;
    name: string = 'AdditionalCoverage';
    lobName: string = null;
    options: any = [
        {
            keyValueID: 'AdditionalChanges',
            fullText: 'Additional Changes',
            shortText: 'Additional Changes',
            description: 'Specify if any additional changes are needed to the above selected quote.',
            value: null,
            displayValue: '',
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class TRIACoverage {
    isTriaCoverage: boolean = false;
    name: string = 'Tria';
    lobName: string = null;
    isWaiveTriaCertify: boolean = false;
    isFileAdded: boolean = false;
    options: any  = [
        {
            keyValueID: 'TriaCoverage',
            fullText: 'TRIA Coverage',
            shortText: 'TRIA Coverage',
            description: 'This is optional coverage. If accepting, you are accepting as quoted or the coverage will be added and reflected in the premium due. If declining, the coverage will not be included when bound.',
            value: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class CyberCoverage {
    isCyberCoverage: boolean = false;
    name: string = 'Cyber';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'CyberCoverage',
            fullText: 'Cyber Suite Coverage',
            shortText: 'Cyber Suite Coverage',
            description: 'This is optional coverage. If accepting, you are accepting as quoted or the coverage will be added and reflected in the premium due. If declining, the coverage will not be included when bound.',
            value: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class AutoCoverage {
    isAutoCoverage: boolean = false;
    name: string = 'Auto';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'NonOwnedAutoCoverage',
            fullText: 'Non-Owned and Hired Auto Liability Coverage',
            shortText: 'Non-Owned and Hired Auto Liability Coverage',
            value: null,
            description: 'This is optional coverage. If accepting, you will be required to provide additional coverage details. If declining, the coverage will not be included in your quote.',
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'NoofEmps',
            fullText: 'Number of Employees',
            shortText: 'Number of Employees',
            value: null,
            description: null,
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'NoofPartners',
            fullText: 'Number of Partners',
            shortText: 'Number of Partners',
            value: null,
            displayValue: 'Not Applicable',
            description: null,
            additionalInfo: null
        },
        {
            keyValueID: 'COH',
            fullText: 'Estimated Cost of Hire',
            shortText: 'Estimated Cost of Hire',
            value: null,
            displayValue: 'Not Applicable',
            description: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class WCCoverage {
    isWCCoverage: boolean = false;
    name: string = 'WorkersCompensation';
    lobName: string = null;
    isCertifyWCOfficersWaiver: boolean = false;
    isFileAdded: boolean = false;
    options: any  = [
        {
            keyValueID: 'IncludedExcludedOfficers',
            fullText: 'WC Officers Inclusion / Exclusion',
            shortText: 'Included or Excluded Officers',
            value: null,
            description: 'Please attach forms for additional included or excluded officers.',
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class RenewalBindMethods {
    getFinalBindRenewalData(_renewal: BindRenewalData) {

        _renewal.renewingPolicies.map(policy => {
            if(policy.quoteDocument) policy.renewOption = '';
            policy.coverages.map(coverage => {
                if(coverage.name === 'Auto') {
                    if(coverage.options[0].value != RenewalCoverageAcceptOptionsValue.DECLINE && (!coverage.options[2].value || coverage.options[2].value === '') )
                        coverage.options[2].value = 0;
                }
            })
        });


        let finalRenewalData = {
            renewalNumber: _renewal.renewalNumber,
            billingType: _renewal.billingType,
            paymentPlan: _renewal.paymentPlan,
            paymentPlanCode: _renewal.paymentPlanCode,
            comment: _renewal.comment,
            renewingPolicies: _renewal.renewingPolicies,
            attachments: _renewal.attachments,
            acknowledge: {
                terms: _renewal.acknowledge.terms,
                payPremium: _renewal.acknowledge.payPremium
            }
        };

        return finalRenewalData;
    }
}

export class BindRenewal {
    selectedStep: string;
    fromReview: boolean = false;
    renewalData: any = new BindRenewalData();
}